import TitleSection from 'components/common/TitleSection';

const ServiceListing = ({ data }) => {
  const titleDetail = {
    upperTitle: '',
    middleTitle: 'All Services',
    lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
  };
  return (
    <section className='serviceListSec DBlock py-10 sm:py-12 px-6 sm:px-10 bg-eventLightPink'>
      <div className='max-w-7xl mx-auto'>
        <TitleSection titleDetail={titleDetail} />
        <div className='DBlock'>
          {data?.map((list) => (
            <div
              key={`serviceLists${list?.id}`}
              className='serviceListCard max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 py-4 gap-6 lg:gap-12'>
              <img
                className='md:order-0 order-1'
                src={list?.image}
                alt='serviceListImg'
              />
              <div className='descSec md:order-1 order-0'>
                <TitleSection titleDetail={list?.titleDetail} />
                <p className='text-sm text-eventGray md:pb-8'>{list?.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceListing;
